<p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>

<p-dialog
  [header]="dialogHeader"
  [(visible)]="showForm"
  [breakpoints]="{ '960px': '75vw' }"
  [style]="{ width: '90vw', height: '80vh', top: '1.5rem' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="true"
  (onHide)="closeDialog()"
  [maximizable]="true"
>
  <div class="card" [formGroup]="validateForm">
    <div class="flex flex-column gap-2">
      <label for="availableToAdministrativeGestion">Tipo</label>
      <p-selectButton
        [options]="competitionTypes"
        formControlName="type"
        optionLabel="label"
        optionValue="value"
      ></p-selectButton>

      <label for="name">Nombre</label>
      <input
        type="text"
        pInputText
        placeholder="Ingrese nombre del evento"
        formControlName="name"
      />

      <label for="discount">Fecha Inicio</label>
      <input
        type="date"
        pInputText
        placeholder="Fecha de inicio evento"
        formControlName="startDate"
      />

      <label for="discount">Fecha Fin</label>
      <input
        type="date"
        pInputText
        placeholder="Fecha de finalización evento"
        formControlName="endDate"
      />

      <label for="name">Lugar</label>
      <input
        type="text"
        pInputText
        placeholder="Ingrese el lugar del evento"
        formControlName="location"
      />

      <label for="discount">Fecha Corte Categorías</label>
      <input
        type="date"
        pInputText
        placeholder="Fecha de corte para la categorización"
        formControlName="baseDateToCalculateAge"
      />

      <label for="discount">Niveles</label>
      <p-multiSelect
        display="chip"
        [showClear]="true"
        [maxSelectedLabels]="7"
        [options]="filteredLevels"
        formControlName="levels"
        optionLabel="name"
        placeholder="Seleccione los niveles para los que participan el evento"
        (onChange)="onLevelSelected($event)"
      ></p-multiSelect>

      <label for="discount">Categorías</label>
      <p-multiSelect
        display="chip"
        [showClear]="true"
        [maxSelectedLabels]="7"
        [options]="categoriesOptions"
        formControlName="categories"
        optionLabel="name"
        optionValue="value"
        placeholder="Seleccione categorías a las que participan el evento"
        (onChange)="onCategorySelected($event)"
      ></p-multiSelect>

      <label for="discount">Inicio Inscripción Ordinarias</label>
      <input
        type="date"
        pInputText
        placeholder="Fecha en la que inician las inscripciones ordinarias"
        formControlName="ordinaryStartDate"
      />

      <label for="discount">Fin Inscripción Ordinarias</label>
      <input
        type="date"
        pInputText
        placeholder="Fecha en la que finalizan las inscripciones ordinarias"
        formControlName="ordinaryEndDate"
      />

      <label for="discount">Inicio Inscripción Extraordinarias</label>
      <input
        type="date"
        pInputText
        placeholder="Fecha en la que inicia las inscripciones extraordinarias"
        formControlName="extraordinaryStartDate"
      />

      <label for="discount">Fin Inscripción Extraordinarias</label>
      <input
        type="date"
        pInputText
        placeholder="Fecha en la que inicia las inscripciones extraordinarias"
        formControlName="extraordinaryEndDate"
      />

      <label for="name">Valor Ordinario Deportista </label>
      <p-inputNumber
        inputId="integeronly"
        formControlName="ordinaryAthleteAmount"
      />

      <label for="name">Valor Extraordinario Deportista </label>
      <p-inputNumber
        inputId="integeronly"
        formControlName="extraordinaryAthleteAmount"
      />

      <label for="name">Valor Ordinario Club </label>
      <p-inputNumber
        inputId="integeronly"
        formControlName="ordinaryClubAmount"
      />

      <label for="name">Valor Extraordinario Club </label>
      <p-inputNumber
        inputId="integeronly"
        formControlName="extraordinaryClubAmount"
      />

      <label for="name">URL Imagen</label>
      <input
      
        type="text"
        pInputText
        placeholder="Ingrese url de la imagen"
        formControlName="urlImage"
      />
      <small id="name-small">Imagen del evento.</small>

      <label for="isActive">Pago Online Habilitado</label>
      <p-selectButton
        [options]="stateOptions"
        formControlName="digitalPaymentAvailable"
        optionLabel="label"
        optionValue="value"
      ></p-selectButton>

      
      <label for="isActive">Pago Manual Habilitado</label>
      <p-selectButton
        [options]="stateOptions"
        formControlName="manualPaymentAvailable"
        optionLabel="label"
        optionValue="value"
      ></p-selectButton>

      <label for="hasCrosselling">Tiene Venta Cruzada</label>
      <p-selectButton
        [options]="stateOptions"
        formControlName="hasCrosselling"
        optionLabel="label"
        optionValue="value"
      ></p-selectButton>

      <!-- Sección de Items de Venta Cruzada -->
      <div *ngIf="validateForm.get('hasCrosselling')?.value" class="mt-3">
        <div class="flex justify-content-between align-items-center mb-2">
          <label class="font-semibold">Items de Venta Cruzada</label>
          <p-button
            label="Agregar Item"
            icon="pi pi-plus"
            size="small"
            (click)="addCrosselingItem()"
          ></p-button>
        </div>
        
        <p-table 
          [value]="crosselingItems" 
          [tableStyle]="{'min-width': '50rem'}"
          *ngIf="crosselingItems.length > 0; else noCrosselingItems">
          <ng-template pTemplate="header">
            <tr>
              <th>Nombre</th>
              <th>Descripción</th>
              <th>Precio</th>
              <th>Acciones</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item let-i="rowIndex">
            <tr>
              <td>{{ item.name }}</td>
              <td>{{ item.description }}</td>
              <td>{{ item.amount | currency:'COP':'symbol':'1.0-0' }}</td>
              <td>
                <p-button
                  icon="pi pi-pencil"
                  size="small"
                  class="mr-2"
                  (click)="editCrosselingItem(item, i)"
                ></p-button>
                <p-button
                  icon="pi pi-trash"
                  severity="danger"
                  size="small"
                  (click)="deleteCrosselingItem(i)"
                ></p-button>
              </td>
            </tr>
          </ng-template>
        </p-table>
        
        <ng-template #noCrosselingItems>
          <p class="text-center text-gray-500 py-3">No hay items de venta cruzada configurados</p>
        </ng-template>
      </div>

      <label for="isActive">Disponible para Inscripción</label>
      <p-selectButton
        [options]="stateOptions"
        formControlName="isOpenToRegister"
        optionLabel="label"
        optionValue="value"
      ></p-selectButton>

      <label for="isActive">Visible para clubes</label>
      <p-selectButton
        [options]="stateOptions"
        formControlName="isPublished"
        optionLabel="label"
        optionValue="value"
      ></p-selectButton>
    </div>

    <div class="flex mt-2 gap-2 justify-content-end">
      <p-button
        label="Cancelar"
        [outlined]="true"
        severity="secondary"
        [rounded]="true"
        (click)="showForm = false"
      ></p-button>
      <p-button
        *ngIf="!isUpdateForm"
        type="submit"
        label="Guardar"
        [rounded]="true"
        [disabled]="validateForm.invalid"
        (click)="saveCompetition()"
      ></p-button>
      <p-button
        *ngIf="isUpdateForm"
        type="submit"
        label="Actualizar"
        [rounded]="true"
        [disabled]="validateForm.invalid"
        (click)="updateCompetition()"
      ></p-button>
    </div>
  </div>
</p-dialog>

<!-- Diálogo para Item de Venta Cruzada -->
<p-dialog
  [header]="editingIndex === -1 ? 'Nuevo Item de Venta Cruzada' : 'Editar Item de Venta Cruzada'"
  [(visible)]="showCrosselingDialog"
  [style]="{ width: '50vw' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeCrosselingDialog()"
>
  <div class="flex flex-column gap-3" *ngIf="editingCrosselingItem">
    <div class="flex flex-column gap-2">
      <label for="crosselingName">Nombre *</label>
      <input
        type="text"
        pInputText
        placeholder="Nombre del item"
        [(ngModel)]="editingCrosselingItem.name"
        required
      />
    </div>

    <div class="flex flex-column gap-2">
      <label for="crosselingDescription">Descripción *</label>
      <textarea
        pInputTextarea
        rows="3"
        placeholder="Descripción del item"
        [(ngModel)]="editingCrosselingItem.description"
        required
      ></textarea>
    </div>

    <div class="flex flex-column gap-2">
      <label for="crosselingAmount">Precio *</label>
      <p-inputNumber
        [(ngModel)]="editingCrosselingItem.amount"
        mode="currency"
        currency="COP"
        locale="es-CO"
        [min]="0"
        placeholder="Precio del item"
        required
      />
    </div>

    <div class="flex flex-column gap-2">
      <label for="crosselingImage">URL Imagen</label>
      <input
        type="text"
        pInputText
        placeholder="URL de la imagen del item"
        [(ngModel)]="editingCrosselingItem.urlImage"
      />
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex gap-2 justify-content-end">
      <p-button
        label="Cancelar"
        [outlined]="true"
        severity="secondary"
        (click)="closeCrosselingDialog()"
      ></p-button>
      <p-button
        label="Guardar"
        [disabled]="!editingCrosselingItem?.name || !editingCrosselingItem?.description || !editingCrosselingItem?.amount"
        (click)="saveCrosselingItem()"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>
